import React from 'react';
import { Row, Col, Typography } from 'antd';
import PostCard from '../../components/PostCard';
import { mockPosts } from '../../api/mockData';

const { Title } = Typography;

const Home = () => {
  return (
    <div>
      <Title level={2} style={{ marginBottom: 24 }}>最新文章</Title>
      <Row gutter={[24, 24]}>
        {mockPosts.map(post => (
          <Col key={post.id} xs={24} sm={12} md={8} lg={6}>
            <PostCard post={post} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Home;